
<template>

  <div id="app">
    <head>
      <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no">
    </head>
   
    <router-view></router-view>

    <!-- 小程序 webview 环境下显示悬浮返回按钮 -->
    <div v-if="isMiniApp" class="back-to-miniapp" @click="backToMiniApp">
      <span class="back-icon">&#8592;</span>
      <span class="back-text">返回</span>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
export default {
  name: 'App',
  data() {
    return {
      isMiniApp: false,
    };
  },
  mounted() {
    // 检测是否在微信小程序 webview 环境中
    const ua = navigator.userAgent.toLowerCase();
    const isWechat = ua.indexOf('micromessenger') !== -1;
    if (isWechat) {
      // 通过 wx-js-sdk 判断是否在小程序内
      // window.__wxjs_environment 在小程序 webview 里会被注入为 'miniprogram'
      if (window.__wxjs_environment === 'miniprogram') {
        this.isMiniApp = true;
      } else {
        // 兼容延迟注入
        setTimeout(() => {
          if (window.__wxjs_environment === 'miniprogram') {
            this.isMiniApp = true;
          }
        }, 300);
      }
    }
  },
  methods: {
    backToMiniApp() {
      // 调用微信 JS-SDK 返回小程序
      if (wx && wx.miniProgram) {
        wx.miniProgram.navigateBack({ delta: 1 });
      }
    },
  },
};
</script>

<style lang="scss">
@import "./assets/sass/app.scss";
@import "./assets/sass/wx.scss";

.back-to-miniapp {
  position: fixed;
  bottom: 80px;
  right: 20px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  user-select: none;

  .back-icon {
    font-size: 18px;
    line-height: 1;
  }

  .back-text {
    font-size: 10px;
    margin-top: 2px;
    line-height: 1;
  }
}
</style>
